import React from 'react';
import styles from './AdminMobileOrderList.module.css';
import FlexChild from 'layouts/flex/FlexChild';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import AdminMobileEmptyMsg from './common/AdminMobileEmptyMsg';
import { mainBgColor, mainPadd2, pageCommonGap1, pageEH2FontSize, pageEH3FontSize, registerGap2 } from '../constraints/AdminConst';
import AdminMobileContentBox from './common/AdminMobileContentBox';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import P from 'components/P';
import backIcon from 'routes/vendorRe/images/back_icon.png';
import { useNavigate } from 'react-router-dom';

const AdminMobileOrderList = ({orders}) => {
    const navigate = useNavigate();
    //

    if (!orders || orders.length === 0) {
        return (
            <VerticalFlex>
                <FlexChild padding={mainPadd2}>
                    <AdminMobileEmptyMsg />
                </FlexChild>
            </VerticalFlex>
        );
    }

    const handleOrderClick = (order) => {
        
        //

        // 상세 페이지로 이동하면서 데이터 전달
        navigate(`/admin/mobile/orderDetail/${order.orderNo}`, { state: { orderData: order } });
    };

    return (
        <VerticalFlex gap={pageCommonGap1} backgroundColor={mainBgColor} padding={mainPadd2}>
            <FlexChild>
                <AdminMobileContentBox flexStart>
                    <VerticalFlex>
                        <FlexChild>
                            <div className={styles.borderBottom}>
                                <HorizontalFlex>
                                    <FlexChild>
                                        <P size={pageEH2FontSize}>발주 내역</P>
                                    </FlexChild>
                                    <FlexChild justifyContent="flex-end" width="auto">
                                        <img className={styles.moveIcon} src={backIcon} alt='이동 아이콘' />
                                    </FlexChild>
                                </HorizontalFlex>
                            </div>
                        </FlexChild>
                        <FlexChild>
                            <VerticalFlex gap={registerGap2}>
                                <FlexChild>
                                {/* 반복구간 */}
                                {orders && orders.map((order, index) => (
                                    <div key={index} className={styles.listMoveClick} onClick={() => handleOrderClick(order)}>
                                        <HorizontalFlex gap={registerGap2}>
                                            <FlexChild width="auto">
                                                {order.mainProductImage ? (
                                                    <img className={styles.productImg} src={order.mainProductImage} alt="대표 이미지" />
                                                ) : (
                                                    <div>이미지 없음</div>
                                                )}
                                            </FlexChild>
                                            <FlexChild>
                                                <VerticalFlex gap={registerGap2}>
                                                    <FlexChild>
                                                        <HorizontalFlex>
                                                            <FlexChild>
                                                                <HorizontalFlex gap={registerGap2}>
                                                                    <FlexChild width="auto">
                                                                        <P size={pageEH3FontSize}>
                                                                            {order.orderDate ? order.orderDate : "날짜 없음"}
                                                                        </P>
                                                                    </FlexChild>
                                                                    <FlexChild>
                                                                        <P size={pageEH3FontSize}>
                                                                            {order.storeName ? order.storeName : "점포명 없음"}
                                                                        </P>
                                                                    </FlexChild>
                                                                </HorizontalFlex>
                                                            </FlexChild>
                                                            <FlexChild width="auto">
                                                                {order.orderStatus ? (
                                                                    <>
                                                                        {order.orderStatus === "accept" && (
                                                                            <div className={styles.statusBox}>
                                                                                <P size={pageEH3FontSize}>접수</P>
                                                                            </div>
                                                                        )}
                                                                        {order.orderStatus === "deliver" && (
                                                                            <div className={styles.statusBox}>
                                                                                <P size={pageEH3FontSize}>배송중</P>
                                                                            </div>
                                                                        )}
                                                                        {order.orderStatus === "cancel" && (
                                                                            <div className={styles.statusCancelBox}>
                                                                                <P size={pageEH3FontSize}>취소</P>
                                                                            </div>
                                                                        )}
                                                                    </>
                                                                ) : (
                                                                    <div>상태 없음</div>
                                                                )}
                                                            </FlexChild>
                                                        </HorizontalFlex>
                                                    </FlexChild>
                                                    <FlexChild alignItems="flex-start">
                                                        <P size={pageEH2FontSize}>
                                                            {order.mainProduct && order.otherProductsString ? `${order.mainProduct} ${order.otherProductsString}` : '상품명 없음'}
                                                        </P>
                                                    </FlexChild>
                                                    <FlexChild alignItems="flex-start">
                                                        <P size={pageEH2FontSize} weight={700}>
                                                            {order.totalOrderAmount ? order.totalOrderAmount.toLocaleString() : 0} 원
                                                        </P>
                                                    </FlexChild>
                                                </VerticalFlex>
                                            </FlexChild>
                                        </HorizontalFlex>
                                    </div>
                                ))}
                                {/* 반복구간 */}
                                </FlexChild>
                            </VerticalFlex>
                        </FlexChild>
                    </VerticalFlex>
                </AdminMobileContentBox>
            </FlexChild>
        </VerticalFlex>
    );
};

export default AdminMobileOrderList;